module.exports = __webpack_public_path__ + "img/rerongji.5139a9cf.jpg";